import {gridStringOrNumberComparator} from "@mui/x-data-grid";

export const nullHandlingSortComparator = (
    v1,
    v2,
    cellParams1,
    cellParams2
) => {
    if (v1 == null || v2 == null) {
        if (v1 == v2) return 0;
        else {
            const sortModel = cellParams1.api.getSortModel();
            const sortColumn = sortModel.find(
                (sm) => sm.field == cellParams1.field
            );
            if (sortColumn && sortColumn.sort == "desc") {
                if (v1 == null) return -1;
                else return 1;
            } else {
                if (v1 == null) return 1;
                else return -1;
            }
        }
    } else {
        return gridStringOrNumberComparator(v1, v2, cellParams1, cellParams2);
    }
};